import React, {useEffect} from 'react';
import FirebaseAnalytic from 'src/nativeModules/FirebaseAnalytic';
import HistoryComponent from 'src/components/elements/account/newHistoryUI/HistoryComponent';
import {filterTypes} from 'src/components/elements/account/AccountHistoryList';
import {NavigationProp} from '@react-navigation/native';
import AccountConstants from '../../../../constants/AccountConstants';

type HistoryComponentProps = {
  histroyfilter?: AccountConstants;
  navigation: NavigationProp<HistoryComponentProps>;
};

const SendASnackHistoryList = (props: HistoryComponentProps) => {
  useEffect(() => {
    const filterValue = filterTypes.sendasnack;
    FirebaseAnalytic.trackEvent(
      'useEffect:componentDidMount',
      'SendASnackHistoryList',
      {
        ...props,
        filterValue,
      },
    );
  }, []);
  return <HistoryComponent histroyfilter={filterTypes.sendasnack} {...props} />;
};

export default SendASnackHistoryList;
